export interface TextureTransition {
    x: number;
    y: number;
}

export enum TextureTransitionType {
    x = 'x',
    y = 'y',
}
